/*
 * Redux initialState and Reducer
 */
const appState = {
    headerIsPinned: false,
    isMobile: false
  },
  appStateReducer = (state = appState, action) => {
    switch (action.type) {
      case 'HEADER_IS_PINNED':
        return Object.assign({}, state, { headerIsPinned: action.headerIsPinned });

      case 'IS_MOBILE':
        return Object.assign({}, state, { isMobile: action.isMobile });

      default:

        return state;
    }
  };

export { appState, appStateReducer };


// WEBPACK FOOTER //
// ./src/reducer.js